export type IBlogUrlParams = {
    slugId: string
}

export class BlogRoute {
    static createUrl = (params: IBlogUrlParams) => {
        const path = `/blog/${params.slugId}`
        return path
    }
}
